import { addForumtReaction, handleRetrieveSingleForum } from "../../../../../redux/public-slices/forum.slice.js";
import { refresher, showDialog, showDialogWithData } from "../../../../../redux/guest-slices/other.slice.js";
import ShareDialog from "../../../../../components/common/dialogs/ShareDialog.jsx";
import { createComment } from "../../../../../redux/guest-slices/common.slice.js";
import { checkUserType, FILE_PATH_URI } from "../../../../../utils/helper.js";
import { Link as NavLink, useLocation, useParams } from "react-router-dom";
import { FORUM_REPORT, GUEST_LOGIN } from "../../../../../utils/keywords.js";
import SkeletonImage from "../../../../../components/ui/SkeletonImage.jsx";
import InputField1 from "../../../../../components/ui/InputField1.jsx";
import { Fragment, useEffect, useRef, useState } from "react";
import Comment from "../../../../../components/ui/Comment.jsx";
import { useToast } from "../../../../../hooks/useToast.js";
import { useDispatch, useSelector } from "react-redux";
import Images from "../../../Home/temp-data/Images.js";
import Icons from "../../../../../assets/js/Icons.js";
import moment from "moment";
import Aside from "./Aside.jsx";

import {
  Alert, Avatar, Box, Button, Container, Divider, Grid2 as Grid,
  Link, Paper, Skeleton, Stack, Typography
} from "@mui/material";

function SingleForum() {
  const toast = useToast();
  const dispatch = useDispatch();
  const commentRef = useRef(null);
  const { forumId } = useParams();
  const [forum, setForum] = useState({});
  const [reply, setReply] = useState({ id: null, view: false });
  const { refresh, loadings } = useSelector((state) => state.otherSlice);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [selectedForumData, setSelectedForumData] = useState(null);
  const location = useLocation();
  const route = location.pathname?.split("/")?.[2];

  // Handle comment reaction
  const handleReaction = async (type) => {
    if (checkUserType()) {
      await dispatch(
        addForumtReaction({
          id: forum?._id,
          formData: { type },
        })
      );
      dispatch(refresher());
    } else {
      handleLogin();
    }
  };

  // Handle get all blogs
  const handleRetrieve = async () => {
    const { forum } =
      (await dispatch(handleRetrieveSingleForum(forumId)).unwrap()) || {};
    setForum(forum);
  };

  // Handle guest login
  const handleLogin = () => {
    dispatch(showDialog(GUEST_LOGIN));
  };

  // Handle add comment
  const handleAddComment = async (isDraft) => {
    const formData = {
      forumId,
      isDraft,
      description: commentRef.current?.value,
    };
    if (!formData?.description || formData?.description?.trim() === "") {
      return toast.error("Please enter comment!");
    }
    const response = await dispatch(createComment(formData));
    if (createComment.fulfilled.match(response)) {
      if (commentRef.current) {
        commentRef.current.value = "";
      }
      dispatch(refresher());
    }
  };

  useEffect(() => {
    handleRetrieve();
    // eslint-disable-next-line
  }, [refresh, route]);
  const handleReport = (element) => {
    if (checkUserType()) {
      dispatch(
        showDialogWithData({
          data: element,
          type: FORUM_REPORT,
        })
      );
    } else {
      handleLogin();
    }
  };

  const handleShareClick = (forumData) => {
    if (!checkUserType()) {
      handleLogin();
      return;
    }
    setSelectedForumData(forumData);
    setShareDialogOpen(true);
  };

  // Handle share dialog close
  const handleShareDialogClose = () => {
    setShareDialogOpen(false);
    setSelectedForumData(null);
  };
  useEffect(() => {
    if (forum?.title) {
      document.title = `${forum.title} - InnerPal`;
    }
  }, [forum?.title]);

  return (
    <Fragment>
      <Box sx={{ py: { xs: 5, lg: 10 }, bgcolor: "#f1f1f1" }}>
        <Container maxWidth={false}>
          <Grid container spacing={4}>
            <Grid size={{ xs: 12, laptop: 8 }}>
              {loadings?.retrieveSingle ? (
                <Skeleton
                  sx={{
                    width: "100%",
                    minHeight: 350,
                    transform: "none",
                  }}
                />
              ) : !forum ? (
                <Alert
                  sx={{
                    fontSize: "20px",
                    fontWeight: "500",
                    alignItems: "center",
                    fontFamily: "Poppins",
                    ".MuiAlert-message": { p: "0" },
                    ".MuiAlert-icon": { fontSize: "28px" },
                  }}
                  color="error"
                  severity="error"
                >
                  No Records Found!
                </Alert>
              ) : (
                <Box
                  sx={{
                    ml: "auto",
                    maxWidth: "1000px",
                    height: "fit-content",
                    position: "sticky",
                    top: 20,

                    overflowY: "auto",
                  }}
                >
                  <Paper
                    sx={{
                      p: 2,
                      gap: 1,
                      display: "flex",
                      borderRadius: "6px",
                      border: "1px solid",
                      borderColor: "divider",
                      flexDirection: "column",
                      transition: "all 450ms ease",
                      boxShadow: "0 0 10px 0 #0000000a",
                      ":hover": {
                        boxShadow: "0 0 10px 0 #00000021",
                      },
                    }}
                  >
                    <Stack
                      spacing={1}
                      direction="row"
                      sx={{
                        alignItems: "center",
                        flexWrap: "wrap",
                        rowGap: "15px",
                      }}
                      divider={<Divider flexItem orientation="vertical" />}
                    >
                      <Avatar
                        sx={{ width: 35, height: 35 }}
                        src={forum?.user?.image}
                      />

                      <Typography
                        fontWeight="600"
                        color="other.color1"
                        textTransform="capitalize"
                      >
                        {" "}
                        {forum?.user?.fullName}
                      </Typography>

                      <Typography color="#272b41" fontSize={{ xs: 14, md: 16 }}>
                        {moment(forum?.createdAt).format("MMM DD YYYY")}
                      </Typography>
                      <Typography color="#272b41" fontSize={{ xs: 14, md: 16 }}>
                        {forum?.comments || 0} Comments
                      </Typography>
                      <Typography color="#272b41" fontSize={{ xs: 14, md: 16 }}>
                        {forum?.views || 0} Views
                      </Typography>
                    </Stack>
                    <Divider sx={{ my: 1, color: "#272b41" }} />

                    <Link
                      // WebkitBoxOrient: "vertical",

                      sx={{
                        mt: 2,
                        width: "100%",
                        overflow: "hidden",
                        WebkitLineClamp: 1,
                        color: "other.color1",
                        display: "-webkit-box",

                        transition: "all 350ms ease",
                        ":hover": {
                          color: "primary.main",
                        },
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "pre-wrap",
                      }}
                      fontSize={28}
                      fontWeight="700"
                      underline="hover"
                      component={NavLink}
                    >
                      {forum?.title}
                    </Link>

                    <Box
                      sx={{
                        width: "100%",
                        overflow: "hidden",
                        borderRadius: "6px",
                        aspectRatio: "1/0.5",
                      }}
                    >
                      <SkeletonImage
                        src={
                          forum?.banner?.path
                            ? FILE_PATH_URI + forum?.banner?.path
                            : Images?.forumImg7
                        }
                      />
                    </Box>

                    <Typography
                      sx={{
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {forum?.description}
                    </Typography>
                    <Stack
                      my={2}
                      spacing={2}
                      direction="row"
                      alignItems="center"
                      flexWrap={"wrap"}
                      sx={{
                        "& > :not(style) ~ :not(style)": {
                          marginLeft: { xs: "5px", sm: "5px" },
                        },
                      }}
                    >
                      <Button
                        size="small"
                        disableRipple
                        color="secondary"
                        sx={{
                          fontSize: "15px",
                          ".MuiButton-icon": { mr: "5px" },
                        }}
                        startIcon={<Icons.ThumbsUpSolid />}
                        onClick={() => {
                          handleReaction("like");
                        }}
                      >
                        Like ({forum?.likes || 0})
                      </Button>
                      <Button
                        size="small"
                        disableRipple
                        color="secondary"
                        sx={{
                          fontSize: "15px",
                          ".MuiButton-icon": { mr: "5px" },
                          ml: "0px",
                        }}
                        startIcon={<Icons.ThumbsDownSolid />}
                        onClick={() => {
                          handleReaction("dislike");
                        }}
                      >
                        Unlike ({forum?.dislikes || 0})
                      </Button>
                      <Button
                        size="small"
                        disableRipple
                        color="secondary"
                        sx={{
                          fontSize: "15px",
                          ".MuiButton-icon": { mr: "5px" },
                          ml: "0px",
                        }}
                        startIcon={<Icons.ShareSolid />}
                        onClick={() => handleShareClick(forum)}
                      >
                        Share
                      </Button>
                      <Button
                        size="small"
                        disableRipple
                        color="secondary"
                        sx={{
                          fontSize: "15px",
                          ".MuiButton-icon": { mr: "5px" },
                        }}
                        startIcon={<Icons.Comment1 />}
                      >
                        Comment ({forum?.comments || 0})
                      </Button>
                      <Button
                        size="small"
                        disableRipple
                        color="secondary"
                        sx={{
                          fontSize: "15px",
                          ".MuiButton-icon": { mr: "5px" },
                        }}
                        startIcon={<Icons.ComplaintSolid />}
                        onClick={() => {
                          handleReport(forum);
                        }}
                      >
                        Report
                      </Button>
                    </Stack>

                    <InputField1
                      name="comment"
                      type="textarea"
                      inputRef={commentRef}
                      placeholder="Write your comment here.."
                    />

                    <Box textAlign="end" mt={2}>
                      {!checkUserType() ? (
                        <Button variant="contained" onClick={handleLogin}>
                          Login to comment
                        </Button>
                      ) : (
                        <Fragment>
                          <Stack
                            direction={{ xs: "column", md: "row" }}
                            spacing={2}
                          >
                            <Button
                              size="large"
                              color="secondary"
                              variant="contained"
                              onClick={() => {
                                handleAddComment(false);
                              }}
                              sx={{
                                width: "100%",
                                justifyContent: "center",
                              }}
                            >
                              Post Comment
                            </Button>
                            <Button
                              size="large"
                              color="secondary"
                              variant="contained"
                              onClick={() => {
                                handleAddComment(true);
                              }}
                              sx={{
                                width: "100%",
                                justifyContent: "center",
                              }}
                            >
                              Save Draft
                            </Button>
                          </Stack>
                        </Fragment>
                      )}
                    </Box>
                  </Paper>

                  <Comment
                    reply={reply}
                    setReply={setReply}
                    comments={forum?.forumComments}
                  />
                </Box>
              )}
            </Grid>
            <Grid size={{ xs: 12, laptop: 4 }}>
              <Box
                sx={{
                  py: 8,
                  px: 3,
                  gap: 10,
                  height: "100%",
                  display: "flex",
                  borderRadius: 2,
                  bgcolor: "#EBF5F5",
                  flexDirection: "column",
                  boxShadow: "0 0 10px 0 #0000000a",
                }}
              >
                <Aside />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <ShareDialog
        open={shareDialogOpen}
        onClose={handleShareDialogClose}
        forumData={selectedForumData}
        id={forum?._id}
      />
    </Fragment>
  );
}

export default SingleForum;
